function escapeCsvValue(value) {
  const text = value == null ? '' : String(value)
  if (text.includes('"') || text.includes(',') || text.includes('\n')) {
    return `"${text.replace(/"/g, '""')}"`
  }
  return text
}

function buildCsv(headers, rows) {
  const lines = []
  lines.push(headers.map(escapeCsvValue).join(','))
  rows.forEach((row) => {
    lines.push(row.map(escapeCsvValue).join(','))
  })
  return '\uFEFF' + lines.join('\n')
}

function downloadBlob(filename, content, mimeType = 'text/csv;charset=utf-8;') {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export function exportTeacherInsightsCsv({ summaryRows = [], studentRows = [], assignmentRows = [] }) {
  const datePart = new Date().toISOString().slice(0, 10)

  const summaryCsv = buildCsv(
    ['kpi', 'valeur'],
    summaryRows.map((row) => [row.label, row.value])
  )
  const studentsCsv = buildCsv(
    ['eleve', 'classe', 'score_moyen', 'tentatives', 'retards', 'inactivite_jours', 'risque', 'motifs'],
    studentRows.map((row) => [
      row.studentName,
      row.className,
      row.averageScore,
      row.attemptCount,
      row.lateAssignments,
      row.inactivityDays,
      row.riskLabel,
      Array.isArray(row.alertReasons) ? row.alertReasons.join(' | ') : ''
    ])
  )
  const assignmentsCsv = buildCsv(
    ['devoir', 'classe', 'rendus', 'taille_classe', 'taux_rendu', 'score_mediane', 'retards'],
    assignmentRows.map((row) => [
      row.title,
      row.className,
      row.submittedCount,
      row.classSize,
      row.submissionRate,
      row.medianScore,
      row.overdueCount
    ])
  )

  downloadBlob(`insights_resume_${datePart}.csv`, summaryCsv)
  downloadBlob(`insights_eleves_${datePart}.csv`, studentsCsv)
  downloadBlob(`insights_devoirs_${datePart}.csv`, assignmentsCsv)
}
